export const SITE_TITLE = process.env.REACT_APP_TITLE || 'Trade Barriers Register'

export const TBR_API_PROJECT_ID = process.env.REACT_APP_TBR_PROJECT_ID
export const TBR_API_DATASET = process.env.REACT_APP_TBR_API_DATASET || 'test'
export const TBR_LAMBDA_BASE = process.env.REACT_APP_TBR_LAMBDA_BASE || 'http://localhost:3000'
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID
export const TBR_API_USE_CDN = process.env.REACT_APP_TBR_API_USE_CDN === 'true'
